import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal as AntModal, Button} from 'antd'

@inject('store') @observer
class Modal extends Component {
  create = () => {
    this.props.close()
    this.props.create()
  }
  render() {
    const {stockFilterLoading} = this.props.store.backtest
    return(
      <AntModal
        visible={this.props.visible}
        onOk={this.create}
        onCancel={this.props.close}
        footer={[
          <Button key="back" onClick={this.props.close}>Close</Button>,
          <Button key="submit" type="primary" loading={stockFilterLoading} onClick={this.create}>
            Create Algo Anyway
          </Button>
        ]}
      >
        <p>Warning: Hand picking stocks based on historical performance increases the chance of overfitting</p>
      </AntModal>
    )
  }
}

export default Modal
